module.exports = __webpack_public_path__ + "img/program-icon-1.d4e7eee4.png";